// Standard library imports
import React, { useEffect, useRef, useState } from 'react';
// External library imports
import Editor from '@monaco-editor/react';
import { useField } from 'formik';

const NewJSONEditor = ({
    defaultValue = {},
    height = 'auto',
    width = 'auto',
    manualDefaultValueUpdate = false,
    setManualDefaultValueUpdate = () => {},
    defaultLanguage = 'json',
    ...props
}) => {
    const [, meta, helpers] = useField(props);

    const [editorRef, setEditorRef] = useState(null);

    const changeHandler = (e) => {
        if (JSON.parse(e)) {
            helpers.setValue && helpers.setValue(JSON.parse(e));
            props.onChange && props.onChange(JSON.parse(e));
        }
    };

    useEffect(() => {
        if (editorRef && manualDefaultValueUpdate) {
            formatJSON(editorRef, defaultValue);
        }
        setManualDefaultValueUpdate(false);
    }, [JSON.stringify(defaultValue), editorRef]);

    const formatJSON = (editor, defaultVal = null) => {
        const unformattedCode = defaultVal ? JSON.stringify(defaultVal) : editor.getValue();
        const res = JSON.parse(unformattedCode);
        const cursorPos = editor.getPosition();
        editor.setValue(JSON.stringify(res, null, 2));
        editor.setPosition(cursorPos);

        return JSON.stringify(res, null, 2);
    };

    const handleEditorDidMount = (editor, monaco) => {
        setEditorRef(editor);
    };

    const formatDefaultJSON = (val = {}) => {
        try {
            const res = JSON.parse(val);
            return JSON.stringify(res, null, 2);
        } catch {
            return JSON.stringify(val, null, 2);
        }
    };

    const formatXml = (xml) => {
        const PADDING = '  '; // 2-space indent
        let formatted = '';
        let pad = 0;

        // Collapse all > < into >\n< and trim
        xml = xml.replace(/>\s*</g, '><').trim();
        xml = xml.replace(/(>)(<)(\/*)/g, '$1\n$2$3');

        const lines = xml.split('\n');

        for (let line of lines) {
            line = line.trim();

            if (line.match(/^<\/.+/)) pad = Math.max(pad - 1, 0);

            formatted += PADDING.repeat(pad) + line + '\n';

            if (line.match(/^<\w[^>]*[^\/]>.*$/) && !line.includes('</')) {
                pad++;
            }
        }

        return formatted.trim();
    };

    return (
        <div>
            <Editor
                height={height}
                defaultLanguage={defaultLanguage}
                theme="vs-dark"
                onChange={changeHandler}
                defaultValue={defaultLanguage === 'xml' ? formatXml(defaultValue) : formatDefaultJSON(defaultValue)}
                onMount={handleEditorDidMount}
            />
            {meta.touched && meta.error ? <div className="error-msg">{meta.error}</div> : null}
        </div>
    );
};

export default NewJSONEditor;
